export default __webpack_public_path__ + "assets/raw-js/basis_transcoder-8a6780ba05c590af561886b4074ca189.js";